import { startOfDay } from "date-fns";
import { somarDias, type PrazoDoLaboratorio } from "@bookdental/schemas";

const TERMINAL_ORDER_STATUSES = ["CONCLUIDO", "CANCELADO"] as const;

/** Pedido atrasado de verdade — prazo já passou e o pedido ainda não terminou (concluído ou
 *  cancelado). Usado na faixa de prazo da Agenda do dentista (ver isServiceOverdue, equivalente
 *  do lado do Kanban de produção do laboratório). */
export function isOrderOverdue(deadline: Date | string | null | undefined, status: string): boolean {
  if (!deadline) return false;
  if ((TERMINAL_ORDER_STATUSES as readonly string[]).includes(status)) return false;
  return startOfDay(new Date(deadline)) < startOfDay(new Date());
}

/** Um pedido é "urgente" quando o prazo escolhido é mais apertado do que o prazo previsto de
 *  atendimento do laboratório (contado a partir de `referenceDate` — "agora" ao montar o pedido,
 *  ou `createdAt` do pedido já existente). Nunca usar o termo técnico "SLA" na UI — dentista e
 *  laboratório usam "prazo previsto"/"expectativa de entrega". */
export function isUrgentDeadline(
  deadline: Date | string | null | undefined,
  referenceDate: Date | string,
  prazo: PrazoDoLaboratorio | null | undefined,
): boolean {
  if (!deadline || !prazo) return false;
  const expectedBy = somarDias(referenceDate, prazo.dias, prazo);
  return startOfDay(new Date(deadline)) < expectedBy;
}
